import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';
import { QuestItemLayout } from 'Layouts/Quests/QuestItemLayout';
import { SeasonPassHeader } from 'Layouts/Quests/SeasonPass/SeasonPassHeader';

const raw = {
  className: 'DefaultQuestsSubLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '37d0666c-ff91-4755-9934-5c3ebfc260b0',
      type: 'Container',
      name: 'tabContainerBack',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'd583d050-6a79-4962-9d29-904bfe722a96',
      type: 'NineSlicePlane',
      name: 'mission_board',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 475,
        y: 300
      },
      width: 950,
      height: 600,
      leftWidth: 102,
      topHeight: 180,
      rightWidth: 92,
      bottomHeight: 141,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_board',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '6ae61f5c-7a3e-42e2-9ad5-af1cbb3dafcf',
      type: 'NineSlicePlane',
      name: 'season_pass_board',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 475,
        y: 300
      },
      width: 950,
      height: 600,
      leftWidth: 102,
      topHeight: 180,
      rightWidth: 92,
      bottomHeight: 141,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_board',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'b22105ef-00a2-4e0b-91eb-d83ad6004ca7',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 437,
      y: -263,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '9d7ddb3e-fef1-4e1b-8234-8e3096c3e3d0',
      type: 'Container',
      name: 'tabContainerFront',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '79fae3af-9b34-4ab3-b5a6-1de7b612744d',
      type: 'Sprite',
      name: 'missionsHeader',
      nameSpace: '',
      className: '',
      x: 0,
      y: -305,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_title_bg',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: '6011ae22-ba1b-411c-823c-cd3b1ea9cc9f',
      type: 'Sprite',
      name: 'button',
      nameSpace: '',
      className: '',
      x: 0,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_orange',
      parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
      data: ''
    },
    {
      id: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 475,
      y: 300,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'd583d050-6a79-4962-9d29-904bfe722a96',
      data: ''
    },
    {
      id: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '6ae61f5c-7a3e-42e2-9ad5-af1cbb3dafcf',
      data: ''
    },
    {
      id: 'aa4caf5d-ed69-4e10-90dc-bc93bdb0b68e',
      type: 'Sprite',
      name: 'tabMissions',
      nameSpace: '',
      className: '',
      x: -200,
      y: -305,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'title_tab_front',
      parent: '9d7ddb3e-fef1-4e1b-8234-8e3096c3e3d0',
      data: ''
    },
    {
      id: '900f2302-5986-45c5-952b-308720245812',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.35,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Quests',
      localize: true,
      maxWidth: 250,
      maxHeight: 80,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: '#8d3321',
        stroke: '#8d3321',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 2,
        dropShadowColor: '#ffffff',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '79fae3af-9b34-4ab3-b5a6-1de7b612744d',
      data: ''
    },
    {
      id: 'e482beb7-8262-42fb-ba89-4571ef036991',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -145,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_title_icon',
      parent: '79fae3af-9b34-4ab3-b5a6-1de7b612744d',
      data: ''
    },
    {
      id: 'bd8a8367-5bdb-4dc3-8dd3-945d7a1e4886',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LetsGo',
      localize: true,
      maxWidth: 189,
      maxHeight: 77,
      maxFontSize: 39,
      icons: [],
      style: {
        fontSize: 39,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#FFFFFF',
        stroke: '#9B2813',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6011ae22-ba1b-411c-823c-cd3b1ea9cc9f',
      data: ''
    },
    {
      id: '5d3b638e-1732-4174-9a51-e037d27f0489',
      type: 'Text',
      name: 'SeasonPassTabTitle',
      nameSpace: '',
      className: '',
      x: 70,
      y: -18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassTabTitle',
      localize: true,
      maxWidth: 205,
      maxHeight: 80,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: '#8d3321',
        stroke: '#8d3321',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 2,
        dropShadowColor: '#ffffff',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0d8fb876-2c83-4fae-90c7-0c78eae9da40',
      data: ''
    },
    {
      id: '11643410-2068-4c66-aea7-049790ea26b7',
      type: 'NineSlicePlane',
      name: 'TabSPProgressBar',
      nameSpace: '',
      className: '',
      x: -166,
      y: -34,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 110,
      height: 35,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_back',
      parent: '0d8fb876-2c83-4fae-90c7-0c78eae9da40',
      data: ''
    },
    {
      id: '8c844442-986f-4361-88d0-0e5a215f8e9e',
      type: 'Layout',
      name: 'quest_item_1',
      nameSpace: '',
      className: 'quests',
      path: 'src/Layouts/Quests/QuestItemLayout.ts',
      percentX: 0,
      percentY: 0,
      x: -290,
      y: -18,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
      data: ''
    },
    {
      id: 'f767b201-0b82-4e38-9fe7-25708c8d36ec',
      type: 'Layout',
      name: 'quest_item_2',
      nameSpace: '',
      className: 'quests',
      path: 'src/Layouts/Quests/QuestItemLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: -18,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
      data: ''
    },
    {
      id: 'e005b4ec-1843-4be5-81a8-f60d46639f4c',
      type: 'Layout',
      name: 'quest_item_3',
      nameSpace: '',
      className: 'quests',
      path: 'src/Layouts/Quests/QuestItemLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 290,
      y: -18,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'c8afd624-913d-41f9-a3a7-3ad6c7776f1c',
      data: ''
    },
    {
      id: '9d30dc74-92cf-487d-b3b1-315c7904765e',
      type: 'Layout',
      name: 'SeasonPassHeader',
      nameSpace: '',
      className: '',
      path: 'src/Layouts/Quests/SeasonPass/SeasonPassHeader.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: -5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: 'adc9d5ce-4c8b-4a86-969b-8db96f19605f',
      type: 'NineSlicePlane',
      name: 'SeasonPassPremiumFieldBG',
      nameSpace: '',
      className: '',
      x: 55,
      y: 110,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 841,
      height: 180,
      leftWidth: 20,
      topHeight: 20,
      rightWidth: 20,
      bottomHeight: 20,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_field_bg',
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: 'ad9dc7fe-4624-41b9-aacd-18f7c680687c',
      type: 'NineSlicePlane',
      name: 'SeasonPassFreeFieldBG',
      nameSpace: '',
      className: '',
      x: 55,
      y: 309,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 841,
      height: 186,
      leftWidth: 20,
      topHeight: 20,
      rightWidth: 20,
      bottomHeight: 20,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'free_field_bg',
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: '67b606d6-467a-4a18-9f38-bb39d1ab93a4',
      type: 'Container',
      name: 'SeasonPassContent',
      nameSpace: '',
      className: '',
      x: 230,
      y: 128,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: '324cc519-3858-415d-a795-ab7aebfd2b26',
      type: 'Sprite',
      name: 'SeasonPassEndScroll',
      nameSpace: '',
      className: '',
      x: 863,
      y: 100,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gradient_scroll_border_right',
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: 'e12d3757-dec0-4928-8728-db5bf6064615',
      type: 'Sprite',
      name: 'SeasonPassStartScroll',
      nameSpace: '',
      className: '',
      x: 199,
      y: 101,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'gradient_scroll_border_left',
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: '903a1741-f31b-4654-ab40-de5e3bb43c42',
      type: 'Sprite',
      name: 'SeasonPassInfoButton',
      nameSpace: '',
      className: '',
      x: 22,
      y: 26,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_info',
      parent: '69dcb0a7-9fb3-49e9-9565-0fd2ee32404e',
      data: ''
    },
    {
      id: '91aef091-0455-402c-8889-05db44006991',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -18,
      anchor: {
        x: 0.35,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Quests',
      localize: true,
      maxWidth: 250,
      maxHeight: 80,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'MyriadProBlack',
        fill: '#8d3321',
        stroke: '#8d3321',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.3,
        dropShadowBlur: 2,
        dropShadowColor: '#ffffff',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 2,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'aa4caf5d-ed69-4e10-90dc-bc93bdb0b68e',
      data: ''
    },
    {
      id: 'df9b23c7-988b-4ab8-8db7-0a211f837ffc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -145,
      y: -20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_title_icon',
      parent: 'aa4caf5d-ed69-4e10-90dc-bc93bdb0b68e',
      data: ''
    },
    {
      id: '6563dc53-d3c1-4edf-92b0-c35c5ae2f787',
      type: 'NineSlicePlane',
      name: 'TabSPProgressBarFill',
      nameSpace: '',
      className: '',
      x: 1,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 110,
      height: 35,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_green',
      parent: '11643410-2068-4c66-aea7-049790ea26b7',
      data: ''
    },
    {
      id: 'bf41e0fe-1fc3-41a6-9138-7e2a988658a4',
      type: 'NineSlicePlane',
      name: 'TabSPProgressBarFrontSprite',
      nameSpace: '',
      className: '',
      x: 1,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 110,
      height: 35,
      leftWidth: 16,
      topHeight: 8,
      rightWidth: 16,
      bottomHeight: 8,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_progress_bar_front',
      parent: '11643410-2068-4c66-aea7-049790ea26b7',
      data: ''
    },
    {
      id: 'b30b0140-dfc6-4fc0-aa9a-8190f7d4d198',
      type: 'Text',
      name: 'TabSPProgressText',
      nameSpace: '',
      className: '',
      x: 61,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1/3',
      localize: false,
      maxWidth: 50,
      maxHeight: 40,
      maxFontSize: 22,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#1c6104',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '11643410-2068-4c66-aea7-049790ea26b7',
      data: ''
    },
    {
      id: '6054c728-18e8-47b2-89a7-8a52ebe9e07d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 110,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpass_icon_milestone',
      parent: '11643410-2068-4c66-aea7-049790ea26b7',
      data: ''
    },
    {
      id: 'bbed7e32-e27d-4c16-a935-8da57642dcfd',
      type: 'Sprite',
      name: 'TabSPIcon',
      nameSpace: '',
      className: '',
      x: 0,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'seasonpoints_icon_title',
      parent: '11643410-2068-4c66-aea7-049790ea26b7',
      data: ''
    },
    {
      id: '6cbacae2-7169-4f95-8f76-a9d3eb66af66',
      type: 'Sprite',
      name: 'PremiumFieldIcon',
      nameSpace: '',
      className: '',
      x: 30,
      y: 80,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_premium_field',
      parent: 'adc9d5ce-4c8b-4a86-969b-8db96f19605f',
      data: ''
    },
    {
      id: '47f36f75-d7f3-4d15-b16c-1196ca15809f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 30,
      y: 80,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_free_field',
      parent: 'ad9dc7fe-4624-41b9-aacd-18f7c680687c',
      data: ''
    },
    {
      id: 'bb63e9bc-a81d-4864-86d4-8e79f11bd02d',
      type: 'Text',
      name: 'TabSPMilestoneText',
      nameSpace: '',
      className: '',
      x: 1,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 120,
      maxHeight: 40,
      maxFontSize: 24,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8d3321',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6054c728-18e8-47b2-89a7-8a52ebe9e07d',
      data: ''
    },
    {
      id: '61ef0427-1274-4c0e-b87d-44cd3940f401',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 56,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassPremiumField',
      localize: true,
      maxWidth: 130,
      maxHeight: 70,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: [
          '#ffff3f',
          '#f58e48'
        ],
        fillGradientStops: [
          0.7,
          0
        ],
        stroke: '#981515',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 31,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.6,
        dropShadowBlur: 0,
        dropShadowColor: '#981515',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '6cbacae2-7169-4f95-8f76-a9d3eb66af66',
      data: ''
    },
    {
      id: 'd1d40db7-0d62-48b9-a018-92bd246b741e',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 56,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SeasonPassFreeField',
      localize: true,
      maxWidth: 130,
      maxHeight: 70,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: [
          '#eef9ff',
          '#6cadce'
        ],
        fillGradientStops: [
          0.7,
          0
        ],
        stroke: '#204a79',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 29,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.6,
        dropShadowBlur: 0,
        dropShadowColor: '#204a79',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '47f36f75-d7f3-4d15-b16c-1196ca15809f',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class DefaultQuestsSubLayout {
  static raw = raw;
  root: PIXI.Container
  tabContainerBack: PIXI.Container
  SeasonPassTabTitle: PIXI.Text
  TabSPProgressBar: PIXI.NineSlicePlane
  TabSPProgressBarFill: PIXI.NineSlicePlane
  TabSPProgressBarFrontSprite: PIXI.NineSlicePlane
  TabSPProgressText: PIXI.Text
  TabSPMilestoneText: PIXI.Text
  TabSPIcon: PIXI.Sprite
  mission_board: PIXI.NineSlicePlane
  quest_item_1: QuestItemLayout
  quest_item_2: QuestItemLayout
  quest_item_3: QuestItemLayout
  season_pass_board: PIXI.NineSlicePlane
  SeasonPassHeader: SeasonPassHeader
  SeasonPassPremiumFieldBG: PIXI.NineSlicePlane
  PremiumFieldIcon: PIXI.Sprite
  SeasonPassFreeFieldBG: PIXI.NineSlicePlane
  SeasonPassContent: PIXI.Container
  SeasonPassEndScroll: PIXI.Sprite
  SeasonPassStartScroll: PIXI.Sprite
  SeasonPassInfoButton: PIXI.Sprite
  closeButton: PIXI.Sprite
  tabContainerFront: PIXI.Container
  tabMissions: PIXI.Sprite
  missionsHeader: PIXI.Sprite
  button: PIXI.Sprite
  quests: (QuestItemLayout)[]

  constructor() {
    populate(this, raw);
  }
}
